module.exports = __webpack_public_path__ + "img/banano-bet-logo-yh_xmas.4fe4643e5a807d894d3724212e6eb1c6.svg";